module.exports = __webpack_public_path__ + "static/media/Rem.54425602.PNG";